<!--
 * @Date         : 2020-11-18 09:36:20
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-16 11:34:26
 * @FilePath     : \leXue_manage_pc\src\views\customer\relationshipList.vue
-->
<template>
  <mainContentDiv class="pa-20">
    <tableList
      ref="tableList"
      v-if="tableOptions"
      :initOptions="tableOptions"
    ></tableList>

    <centerDialog ref="centerDialog">
      <div class="overflow-hidden">
        <div
          class="d-flex flex-wrap"
          style="margin-right: -0.625rem"
          v-if="initOptions_input"
        >
          <div
            class="col-6"
            v-for="(item, index) in initOptions_input.inputList"
            :key="index"
          >
            <div class="mr-10 mb-10">
              <div
                class="my-5 com-title"
                v-if="item.label"
                :class="{
                  active:
                    item.rules &&
                    item.rules.find((item) => item === 'required'),
                }"
              >
                {{ item.label }}
              </div>
              <!-- 输入框 -->
              <textFile v-if="item.type === 'input'" :initOptions="item">
              </textFile>
            </div>
          </div>
        </div>
      </div>
    </centerDialog>
  </mainContentDiv>
</template>

<script>
export default {
  data() {
    return {
      tableOptions: null,
      initOptions_input: null,
    };
  },
  props: {
    isSelect: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.tableOptions = this.getTableOptions();
  },
  methods: {
    // 弹出新增/编辑学校
    renderShipDialog({ type, inputedVal }) {
      try {
        let inputOptions = (this.initOptions_input = {
          inputList: this.getInputStudent(),
        });

        if (inputedVal) {
          this.$com.fillData({
            inputList: this.initOptions_input.inputList,
            valueListObj: inputedVal,
          });
        }

        return new Promise((resovle, reject) => {
          this.$refs.centerDialog.render({
            title: type === 1 ? "新增" : "编辑",
            width: "600px",
            ok: async () => {
              try {
                const { inputList } = inputOptions;

                let requestOpt = this.$com.getValueByRules(inputList);
                let apiKey;

                switch (
                  type // 1:新增 2:编辑
                ) {
                  case 1:
                    apiKey = "addRelation";
                    break;
                  case 2:
                    const { id } = inputedVal;

                    apiKey = "editRelation";

                    requestOpt.id = id;
                    break;
                }

                const { msg } = await this.$ajax({
                  apiKey,
                  data: requestOpt,
                });

                this.$toast({
                  msg,
                });

                resovle();
              } catch (error) {
                reject(error);
                throw error;
              }
            },
          });
        });
      } catch (error) {
        this.$catchError(error);
      }
    },

    //获取输入配置表
    getInputStudent(inputedValueObj) {
      let getInputStudent = [
        {
          type: "input",
          label: "关系",
          placeholder: "请输入关系",
          maxLength: 40,
          rules: ["required", "!null"],
          value: null,
          props: "name",
        },
      ];

      return getInputStudent;
    },

    getTableOptions() {
      const isSelect = this.isSelect; //选择模式

      return {
        authenKey: "studentAndParentRelation_list",
        search: {
          inputList: [
            {
              type: "input",
              label: "关系名",
              placeholder: "",
              value: "",
              props: "name",
              rules: ["!null"],
            },
          ],
        },
        headers: [{ label: "关系名", props: "name" }],
        titleBtns: [
          {
            type: "filter",
            title: "查询",
          },
          {
            title: "新增关系",
            authenKey: "studentAndParentRelation_add",
            onTap: async () => {
              await this.renderShipDialog({
                type: 1,
              });
              this.$refs.tableList.init(); //刷新数据
            },
          },
        ],
        actionBtns: [
          {
            title: "编辑",
            color: "cyan",
            authenKey: "studentAndParentRelation_edit",
            onTap: async (options) => {
              await this.renderShipDialog({
                type: 2,
                inputedVal: options,
              });
              this.$refs.tableList.init(); //刷新数据
            },
          },
          {
            title: "删除",
            color: "red",
            authenKey: "studentAndParentRelation_del",
            onDelete: async (options) => {
              return await this.$ajax({
                apiKey: "delRelation",
                data: {
                  id: options.id,
                },
              });
            },
          },
        ],
        getData: async (options) => {
          const ret = await this.$ajax({
            apiKey: "getRelationList",
            data: options,
          });

          return ret;
        },
      };
    },
  },
};
</script>
